<template>
  <generic-container
    icon="list"
    :title="$t('bulk processes')"
    :header_buttons="header_buttons"
    :show_refresh="true"
    :show_back="true"
    @refresh="init"
  >
    <table
      class="ui blue very compact celled striped selectable table"
      ref="table"
      style="width: 100%"
    >
      <thead>
        <tr>
          <th>{{ $t("create date") }}</th>
          <th>{{ $t("user") }}</th>
          <th>{{ $t("scheduled date") }}</th>
          <th>{{ $t("details") }}</th>
          <th>{{ $t("status") }}</th>
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <import-modal ref="import_modal" @import_succedded="init" />
  </generic-container>
</template>

<script>
import filters from "@/filters";
import {
  local_api,
  enterprise_setup,
  error_toast,
  init_ajax_data_datables,
  success_toast,
} from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import ImportModal from "./import_modal/Index";

// @ is an alias to /src
export default {
  name: "VisalinkGeneratorBulkIndex",
  components: {
    "generic-container": GenericContainer,
    ImportModal,
  },
  filters: filters,
  data() {
    return {
      datatable: {},
      header_buttons: [
        {
          icon: "file import",
          click: this.import_bulk,
          tooltip: this.$t("import bulk"),
        },
        // {
        //   icon: "play",
        //   click: this.start_bulk,
        //   tooltip: this.$t("start bulk"),
        // },
      ],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    init() {
      let vm = this;
      let columns = [
        {
          data: function (row) {
            return filters.formatDate(
              row.create_date,
              vm.enterprise_setup.detailed_date_format,
            );
          },
        },
        {
          data: function (row) {
            return `${row.usr_user.name} (${row.usr_user.username})`;
          },
        },
        {
          data: function (row) {
            if (row.scheduled_date)
              return filters.formatDate(
                row.scheduled_date,
                vm.enterprise_setup.detailed_date_format,
              );
            else return "";
          },
        },
        {
          data: function (row) {
            let html = `<div class="ui mini statistic">
  <div class="value">
    ${row.bulk_size}
  </div>
  <div class="label">
    ${vm.$t("total")}
  </div>
</div>`;
            html = row.groups.reduce((prev, curr) => {
              return `${prev}<div class="ui mini ${vm.calculate_color(
                curr,
              )} statistic">
  <div class="value">
    ${curr.elements}
  </div>
  <div class="label">
    ${vm.decode_status(curr)}
  </div>
</div>`;
            }, html);
            return html;
          },
        },
        {
          data: function (row) {
            switch (row.status_code) {
              case "F":
                return vm.$t("finished");
              case "W":
                return vm.$t("waiting");
              case "R":
                return vm.$t("running");
              case "E":
                return vm.$t("errored");
              case "S":
                return vm.$t("stopped");
              default:
                return row.status_code;
            }
          },
        },
        {
          data: function (row) {
            // return `<div class="ui tiny icon blue button" onclick="window.dispatchEvent(new Event('start_bulk', {bulk_id:${row.bulk_id}}))"><i class="play icon"></i><div>`;
            let btns = `<div class="ui tiny basic icon button" data-tooltip="${vm.$t(
              "process waiting elements",
            )}" onclick="window.dispatchEvent(new CustomEvent('start_bulk', {'detail':${
              row.bulk_id
            }}))"><i class="play blue icon"></i></div>
            <div class="ui tiny basic icon button" data-tooltip="${vm.$t(
              "process errored elements",
            )}" onclick="window.dispatchEvent(new CustomEvent('reprocess_bulk', {'detail':${
              row.bulk_id
            }}))"><i class="play red icon"></i></div>
            <div class="ui red tiny basic icon button" data-tooltip="${vm.$t(
              "delete bulk",
            )}" onclick="window.dispatchEvent(new CustomEvent('delete_bulk', {'detail':${
              row.bulk_id
            }}))"><i class="trash icon"></i></div>`;
            if (row.status_code == "R")
              btns += `<div class="ui tiny basic icon button" data-tooltip="${vm.$t(
                "stop processing",
              )}" onclick="window.dispatchEvent(new CustomEvent('stop_bulk', {'detail':${
                row.bulk_id
              }}))"><i class="red stop icon"></i></div>`;
            return btns;
          },
        },
      ];

      let onSelect = (/* data */) => {
        // vm.$refs.detail_modal.show_modal(data);
      };

      vm.datatable = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["visalink generator bulk url"],
        columns,
        onSelect,
      );
    },
    import_bulk() {
      let vm = this;
      // let trgtButton = vm.header_buttons.find((x) => x.icon == "file import");

      vm.$refs.import_modal.show_modal();

      // if (trgtButton) trgtButton.icon = "file import loading";
      // local_api(vm, "post", "/visalink_generator/bulk/do-import", {})
      //   .then(() => {
      //     success_toast(
      //       vm.$t(
      //         "import succedded, the process is now working on building visalinks",
      //       ),
      //     );
      //     vm.init();
      //     if (trgtButton) trgtButton.icon = "file import";
      //   })
      //   .catch((err) => {
      //     error_toast(err);
      //     if (trgtButton) trgtButton.icon = "file import";
      //   });
    },
    calculate_color(itm) {
      // let vm = this;
      if (itm && itm.status_code) {
        switch (itm.status_code) {
          case "W":
            return "orange";
          case "C":
            return "green";
          case "E":
            return "red";
          default:
            return "purple";
        }
      } else {
        return "grey";
      }
    },
    decode_status(itm) {
      let vm = this;
      if (itm && itm.status_code) {
        switch (itm.status_code) {
          case "W":
            return vm.$t("waiting");
          case "C":
            return vm.$t("created");
          case "E":
            return vm.$t("errored");
          default:
            return itm.status_code;
        }
      } else {
        return "?";
      }
    },
  },
  created() {
    // let vm = this;
    // window.addEventListener(
    //   "start_bulk",
    //   (event) => {
    //     event.stopImmediatePropagation();
    //     let bulk_id = event.detail;
    //     local_api(vm, "post", "/visalink/bulk/do-start", { i: bulk_id })
    //       .then(() => {
    //         success_toast(vm.$t("bulk is running"));
    //       })
    //       .catch((err) => {
    //         error_toast(err);
    //       });
    //   },
    //   false,
    // );
  },
  mounted() {
    let vm = this;
    // setTimeout(() => {
    vm.init();
    // }, 500);
    // window.jQuery(vm.$refs.range_start).calendar({
    //   today: true,
    //   type: "datetime",
    //   endCalendar: window.jQuery(vm.$refs.range_end),
    //   onSelect(value) {
    //     vm.start_date = value;
    //   },
    // });
    // window.jQuery(vm.$refs.range_end).calendar({
    //   today: true,
    //   type: "datetime",
    //   startCalendar: window.jQuery(vm.$refs.range_start),
    //   onSelect(value) {
    //     vm.end_date = value;
    //   },
    // });
    window.addEventListener(
      "start_bulk",
      (event) => {
        event.stopImmediatePropagation();
        let bulk_id = event.detail;
        local_api(vm, "post", "/visalink_generator/bulk/do-start", {
          i: bulk_id,
        })
          .then(() => {
            success_toast(vm.$t("bulk process started"));
          })
          .catch((err) => {
            error_toast(err);
          });
      },
      false,
    );

    window.addEventListener(
      "reprocess_bulk",
      (event) => {
        event.stopImmediatePropagation();
        let bulk_id = event.detail;
        local_api(vm, "post", "/visalink_generator/bulk/do-reprocess", {
          i: bulk_id,
        })
          .then(() => {})
          .catch((err) => {
            error_toast(err);
          });
      },
      false,
    );

    window.addEventListener(
      "delete_bulk",
      (event) => {
        event.stopImmediatePropagation();
        let bulk_id = event.detail;

        vm.$alertify.confirm(
          vm.$t("are you sure to remove bulk?"),
          function () {
            local_api(vm, "post", "/visalink_generator/bulk/do-delete", {
              u: bulk_id,
            })
              .then(() => {
                vm.init();
              })
              .catch((err) => {
                error_toast(err);
              });
          },
        );
      },
      false,
    );

    window.addEventListener(
      "stop_bulk",
      (event) => {
        event.stopImmediatePropagation();
        let bulk_id = event.detail;

        vm.$alertify.confirm(vm.$t("are you sure to stop bulk?"), function () {
          local_api(vm, "post", "/visalink_generator/bulk/do-stop", {
            u: bulk_id,
          })
            .then(() => {
              vm.init();
            })
            .catch((err) => {
              error_toast(err);
            });
        });
      },
      false,
    );
  },
  watch: {},
};
</script>
